import { render } from "./JapaneseInput.vue?vue&type=template&id=d00f441e&ts=true"
import script from "./JapaneseInput.vue?vue&type=script&lang=ts"
export * from "./JapaneseInput.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__